import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=63364e16"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"
import style0 from "./Setting.vue?vue&type=style&index=0&id=63364e16&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports